module.exports = __webpack_public_path__ + "img/empty.abcffa17.png";